 import axios from 'axios';
import {useState, useEffect, useReducer} from 'react'
import './App.css';

const formReducer = (state, event) => {
  if(event.reset) {
   return {
     title: '',
     count: 0,
     name: '',
     'gift-wrap': false,
   }
 }
  return {
    ...state,
    [event.name]: event.value
  }
}
function App() {
const [message, setmessage] = useState("")

  const [formData, setFormData] = useReducer(formReducer, {
    count: 100
  });
  const [submitting, setSubmitting] = useState(false);

  const  handleSubmit =  async event => {
    event.preventDefault();
    setSubmitting(true);

  
      setSubmitting(false);
      let payload = { to: 'ExponentPushToken[8XK9oVFI1GAzcO4-iFgpfX]', title: formData.title, body : formData.name };

      let res = await axios.post('https://exp.host/--/api/v2/push/send', payload);
  
      let data = res.data;
      console.log(data);
      setmessage(data.data.status)
      console.log(formData.name, " ", formData.title)
      setFormData({
       reset: true
     })
    
  }


  const handleChange = event => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    })
  }

 
  return (
    <div className="App">

    <form onSubmit={handleSubmit}>
        <fieldset disabled={submitting}>
          <label>
            <p>Title</p>
            <input name="title" onChange={handleChange} value={formData?.title || ''}/>
          </label>
        </fieldset> 
        <fieldset disabled={submitting}>
          <label>
            <p>Name</p>
            <input name="name" onChange={handleChange} value={formData?.name || ''}/>
          </label>
        </fieldset> 
          {/* <label>
            <p>Apples</p>
            <select name="apple" onChange={handleChange} value={formData.apple || ''}>
                <option value="">--Please choose an option--</option>
                <option value="fuji">Fuji</option>
                <option value="jonathan">Jonathan</option>
                <option value="honey-crisp">Honey Crisp</option>
            </select>
          </label> */}
     
        <button type="submit" disabled={submitting}>Submit</button>
      </form>

      <h4>{message}</h4>
    </div>
  );
}

export default App;
